import { render, staticRenderFns } from "./TypingBubble.vue?vue&type=template&id=492da42a"
import script from "./TypingBubble.vue?vue&type=script&lang=js"
export * from "./TypingBubble.vue?vue&type=script&lang=js"
import style0 from "./TypingBubble.vue?vue&type=style&index=0&id=492da42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports